import { Component } from '@angular/core';

@Component({
  selector: 'app-mathjax',
  templateUrl: './mathjax.component.html',
  styleUrl: './mathjax.component.scss',
  standalone: false
})
export class MathjaxComponent {

}
